import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 6.667h.667a.667.667 0 1 0 0-1.334H6a.667.667 0 0 0 0 1.334M6 8a.667.667 0 0 0 0 1.333h4A.667.667 0 1 0 10 8zm7.333-2.04a1 1 0 0 0-.04-.18v-.06a.7.7 0 0 0-.126-.187l-4-4a.7.7 0 0 0-.187-.126.2.2 0 0 0-.06 0 .6.6 0 0 0-.22-.074H4.667a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V5.96m-4-2.353 1.727 1.726H10a.667.667 0 0 1-.667-.666zM12 12.667a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V3.333a.667.667 0 0 1 .667-.666H8v2a2 2 0 0 0 2 2h2zm-2-2H6A.667.667 0 1 0 6 12h4a.667.667 0 1 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })